import React from 'react';

import ActionLink from '../builder/ActionLink';
import { useOwner } from '../context/context';
import { ProfileModule } from '../ui_items/Module.js';

const ExtraTips = (props) => {	
	const owner = useOwner();

	const promotion = owner?.promotion?.Promotion ?? false;
	if(promotion === false) return null;

	return (
		<ProfileModule title={{ label:"It may also help you", icon:'knk-tip' }}>
			<ul class="gui_clean_listed_elements">
				<li class="gui_multiline_links">
					<div>
						<ActionLink
							_class={{
								icon:'knk-arrow-r-big',
								other:'gui_padded_icon gui_small_icon',
							}}
							_href={`/buzz/widget/${promotion.id}`}
						>Embed the contest as a widget in your website</ActionLink>
					</div>
				</li>

				<li class="gui_multiline_links">
					<div>
						<ActionLink
							_class={{
								icon:'knk-arrow-r-big',
								other:'gui_padded_icon gui_small_icon',
							}}
							_href={`${window.zendesk_base_url}207885366`}
							_target="_blank"
						>Review the guide to measure the traffic sources</ActionLink>
					</div>
				</li>
			</ul>
		</ProfileModule>
	);
}

export default ExtraTips;